/**
 * Auto generated file using cli command
 * _> cronos front-enum
 * !! DO NOT EDIT THIS FILE MANUALLY !!
 * Manual changes will be overwritten
 */

export enum TITLE {
	Madam = 1,
	Mister = 2,
}
